import Button from "@edaz/edazkit/Button";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import type ChargeOrderSearchResponse from "entities/chargeOrderSearchResponse";
import { observer } from "mobx-react-lite";
import React from "react";
import { ButtonToolbar } from "react-bootstrap";
import PairingByPaymentOrdersViewModel from "viewModels/finance/paymentsPairing/pairingByPayment/pairingByPaymentOrdersViewModel";
import ChargeOrderStatus from "entities/chargeOrderStatus";
import ListView from "../../../common/list";
import OrderFilters from "../orderFilters";
import { ChargeOrderSearchColumnsDefinition } from "../pairingByOrder/pairingByOrderListView";

const PairingByPaymentOrdersView: ViewComponent<PairingByPaymentOrdersViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<ChargeOrderSearchResponse>[] = [
    ...ChargeOrderSearchColumnsDefinition(vm),
    {
      cellClassName: "sticky",
      headerClassName: "sticky",
      valueFormatter: props => {
        if (props.item.status !== ChargeOrderStatus.Paid && vm.allowToPair) {
          return (
            <ButtonToolbar className="justify-content-end">
              <Button className="rounded" size="sm" onClick={() => vm.onPairOrderClick(props.item)}>
                {vm.translate("pair")}
              </Button>
            </ButtonToolbar>
          );
        }

        return null;
      },
    },
  ];

  return (
    <>
      <h4 className="mt-4">{vm.translate("orderSearch")}</h4>
      <OrderFilters vm={vm} />
      <div className="full-width" style={{ overflowX: "auto" }}>
        <ListView
          vm={vm}
          columns={columns}
          hideTitle={true}
          mandatoryFilter={true}
          rowProps={item => {
            if (item === vm.openOrder) {
              return {
                className: "table-active",
              };
            } else if (item.status === ChargeOrderStatus.Paid) {
              return {
                className: "text-danger",
              };
            }

            return {};
          }}
        />
      </div>
    </>
  );
});

registerView(PairingByPaymentOrdersView, PairingByPaymentOrdersViewModel);
